import script from "./OpenPrivateSummaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenPrivateSummaryView.vue?vue&type=script&setup=true&lang=js"

import "./OpenPrivateSummaryView.vue?vue&type=style&index=0&id=5b8c9700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b8c9700"]])

export default __exports__